import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PhotoDropzoneAuraComponent } from '../../inputs';

@Component({
  selector: 'aura-photo-upload-modal',
  standalone: true,
  imports: [PhotoDropzoneAuraComponent],
  templateUrl: './photo-upload-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoUploadModalAuraComponent {
  private dialogRef = inject(MatDialogRef<PhotoUploadModalAuraComponent>);

  onFilesSelected(files: File[]) {
    // When files are selected, we pass them back immediately to upload them
    this.dialogRef.close(files);
  }

  close() {
    this.dialogRef.close(null);
  }
}
